module.exports = __webpack_public_path__ + "images/map/map-marker-yellow-af3496dea0b109fed46d35ecb00f6e7b.png";